<h1 mat-dialog-title>{{ input?.label }}</h1>
<div mat-dialog-content>
    <kiene-selector [selectorInput]="input" (optionSelected)="selectOption($event)"></kiene-selector>
</div>
<div mat-dialog-actions>
    <button mat-flat-button (click)="close()">Schließen</button>
    <button mat-flat-button color="accent" (click)="save()">Auswählen</button>
</div>
